export enum LocalStorageKeys {
    PWA_POPUP_DATE = 'pwa_popup_date'
}
